module.exports = __webpack_public_path__ + "static/img/image_home_04.2a1ccdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/home/image_home_04.png
// module id = Mect
// module chunks = 10